import {Component, OnInit} from '@angular/core';
import {User} from '../../model/user';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {UserContactService} from './user-contact.service';
import {NotifierService} from '../notifier/notifier.service';
import {NotificationType} from '../notifier/notification-type.enum';
import {CommonService} from '../../common/common.service';
import {BreadcumbsService} from "../breadcumbs/breadcumbs.service";

@Component({
  selector: 'pbc-user-contact',
  templateUrl: './user-contact.component.html',
})
export class UserContactComponent implements OnInit {

  private loggedUser : User;
  contactForm : FormGroup;

  constructor(private userContactService : UserContactService,
              private notifierService : NotifierService,
              private commonService : CommonService,
              private breadcumbsService: BreadcumbsService
              ) { }

  ngOnInit() {
    let authData = JSON.parse(localStorage.getItem('auth_data'));
    this.loggedUser = authData.user;

    this.contactForm = new FormGroup({
      'firstName' : new FormControl(''),
      'lastName' : new FormControl(''),
      'message' : new FormControl('', Validators.required),
      'subject' : new FormControl('', Validators.required),
      'sendCopy' : new FormControl(false),
      'agreement' : new FormControl(false, Validators.requiredTrue)
    });

    this.contactForm.controls['firstName'].setValue(this.loggedUser.firstName);
    this.contactForm.controls['lastName'].setValue(this.loggedUser.lastName);
    setTimeout(()=>this.breadcumbsService.setSubfolder.emit('Kontakt'),100);
  }

  sendMessage() {
    let subject = this.contactForm.controls['subject'].value;
    let message = this.contactForm.controls['message'].value;
    let sendCopy = this.contactForm.controls['sendCopy'].value;
    let firstName = this.contactForm.controls['firstName'].value;
    let lastName = this.contactForm.controls['lastName'].value;

    this.commonService.sendEnquiry(this.loggedUser.email, firstName, lastName, message, subject, sendCopy).subscribe(
      result => {
        if (result.status ==1)
          this.notifierService.notify(NotificationType.SUCCESS_NOTIFICATION,
            "Wysłano wiadomość do administratorów Serwisu");
        else
          this.notifierService.notify(NotificationType.ERROR_NOTIFICATION,
            "Wystąpił błąd! Nie wysłano wiadomości do aministatorów Serwisu");
      },
      error => {
        console.log(error);
        this.notifierService.notify(NotificationType.ERROR_NOTIFICATION,
          "Wystąpił błąd! Wysłano wiadomość do administratorów Serwisu");
      }
    );

    this.contactForm.controls['sendCopy'].reset(false);
    this.contactForm.controls['message'].reset('');
    this.contactForm.controls['subject'].reset(null);
  }

}
